import * as constant from "../Constants";
import { BaseService, BaseQuery, BaseBuilder } from "../Base";

class CustomBuilder extends BaseBuilder {
  parameter = {};
  addUser(value) {
    this.parameter.user = value;
    return this;
  }
  build() {
    return new CustomQuery(this.parameter).query;
  }
}

class CustomQuery extends BaseQuery {
  constructor(build) {
    if (build !== undefined) {
      super(build);
    }
    super();
  }
  static get Builder() {
    return CustomBuilder;
  }
}

export class Service extends BaseService {
  constructor() {
    super();
    this.configuration = {
      ...this.configuration,
      method: constant.BASE.method.get,
      resource: constant.BASE.resource.logout
    };
    this.query = new CustomQuery.Builder();
  }
}
